module.exports = __webpack_public_path__ + "media/images/top/top_user_img_04-d244b59c950e675871ee1285e47e58f9.png";